/**
 * Global Variable Management Page
 * 
 * Page component for managing global variables.
 * Uses the selected company from UserContext.
 */

import React from 'react';
import { Alert, Select, Space, Typography } from 'antd';
import { GlobalVariableManager } from '../components/PrimeModel/GlobalVariableManager';
import { useUser } from '../contexts/UserContext';

const { Title } = Typography;
const { Option } = Select;

export const GlobalVariableManagementPage: React.FC = () => {
  const { selectedCompany, availableCompanies, selectCompany } = useUser();
  const [selectedCompanyId, setSelectedCompanyId] = React.useState<string | null>(
    selectedCompany?.id || null
  );

  React.useEffect(() => {
    if (selectedCompany?.id) {
      setSelectedCompanyId(selectedCompany.id);
    }
  }, [selectedCompany]);

  const handleCompanyChange = (companyId: string) => {
    setSelectedCompanyId(companyId);
    selectCompany(companyId);
  };

  if (!selectedCompanyId) {
    return (
      <div style={{ padding: '24px' }}>
        <Title level={2}>Global Variables</Title>
        <Alert
          message="No Company Selected"
          description="Please select a company to manage global variables."
          type="info"
          showIcon
        />
        {availableCompanies.length > 0 && (
          <div style={{ marginTop: '16px' }}>
            <Space>
              <span>Select Company:</span>
              <Select
                placeholder="Select a company"
                style={{ width: 300 }}
                onChange={handleCompanyChange}
              >
                {availableCompanies.map((uc) => (
                  <Option key={uc.company.id} value={uc.company.id}>
                    {uc.company.name}
                  </Option>
                ))}
              </Select>
            </Space>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: '16px' }}>
        <Space>
          <Title level={2} style={{ margin: 0 }}>
            Global Variables
          </Title>
          {availableCompanies.length > 1 && (
            <Select
              value={selectedCompanyId}
              onChange={handleCompanyChange}
              style={{ width: 300 }}
            >
              {availableCompanies.map((uc) => (
                <Option key={uc.company.id} value={uc.company.id}>
                  {uc.company.name}
                </Option>
              ))}
            </Select>
          )}
        </Space>
      </div>
      <GlobalVariableManager companyId={selectedCompanyId} />
    </div>
  );
};

